<template>
  <b-container fluid>
    <b-modal
      v-model="showModalFilter"
      centered
      size="md"
      title="Filter Data"
      @ok="fetchData"
      ok-title="Filter"
    >
      <b-row class="mb-2">
        <b-col md="4">
          <label class="b-label">Date</label>
        </b-col>
        <b-col md="8">
          <date-picker class="mr-2 w-100" v-model="filterDate"></date-picker>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col md="4">
          <label class="b-label">Status</label>
        </b-col>
        <b-col md="8">
          <v-multiselect
            :multiple="true"
            label="name"
            track-by="value"
            :options="statusOptions"
            v-model="statusSelected"
          ></v-multiselect>
        </b-col>
      </b-row>
    </b-modal>
    <b-sidebar
      v-model="showCanvas"
      right
      width="50%"
      bg-variant="white"
      title="Add New Running Hours"
      header-class="p-0"
      shadow
      backdrop
    >
      <template #header>
        <div
          class="w-100 p-2 px-3 d-flex justify-content-between align-items-center"
          style="
            border-bottom: 1px solid #ced4da;
            font-size: 18px;
            font-weight: 600;
          "
        >
          <i class="fa fa-close cursor-pointer" @click="showCanvas = false"></i>
          <p class="m-0"
            >{{ selectedData ? 'Detail' : 'Create' }} Adjusment Running Hours</p
          ></div
        >
      </template>
      <template>
        <FormAdjustmentRunningHours
          v-if="showCanvas"
          :selectedData="selectedData"
          @refetch="fetchData"
          @close="showCanvas = false"
        />
      </template>
    </b-sidebar>
    <iq-card>
      <template #headerTitle>
        <h5 class="card-title text-primary">
          <strong>ADJUSTMENT RUNNING HOURS</strong>
        </h5>
      </template>
      <template #body>
        <b-row>
          <b-col md="6" class="mb-3 d-flex">
            <div class="d-flex">
              <b-input
                placeholder="Search.."
                style="width: 200px"
                v-model="filterSearch"
              ></b-input>
              <b-button variant="primary" class="ml-2" @click="fetchData"
                ><i class="fa fa-search"></i
              ></b-button>
            </div>
            <b-button
              variant="outline-primary"
              class="ml-2"
              @click="showModalFilter = true"
            >
              <i class="fa fa-sliders"></i>
              Filter Data</b-button
            >
          </b-col>
          <b-col md="6" class="d-flex justify-content-end">
            <b-button
              variant="primary"
              style="height: max-content"
              @click=";(showCanvas = true), (selectedData = null)"
              >Create Adjustment Running Hours</b-button
            >
          </b-col>
          <b-col md="12">
            <table class="w-100 table-striped">
              <thead>
                <th>FLEET </th>
                <th>TRANSACTION ID</th>
                <th>CREATOR BY</th>
                <th>EFFECTIVE DATE</th>
                <th>STATUS</th>
                <th>ACTION</th>
              </thead>
              <tbody v-if="!loading">
                <template v-for="(item, i) in adjustments.data">
                  <tr :key="`${i}`">
                    <td
                      ><b-badge variant="success">{{
                        item.vehicle?.name
                      }}</b-badge></td
                    >
                    <td
                      >TRX-ADJSRH-{{ item?.id }}-{{
                        item?.effective_date
                          ? moment(item?.effective_date).format('MMYYYY')
                          : ''
                      }}</td
                    >
                    <td>
                      <UserTemplate
                        :userDetail="{
                          name: item?.user?.requestor?.name,
                          photo: item?.user?.requestor?.photo,
                          position: item?.user?.detail?.department?.name,
                        }"
                      />
                    </td>
                    <td>{{ item?.effective_date ?? '-' }}</td>
                    <td>
                      <b-alert
                        show
                        class="p-0 m-0 text-capitalize d-flex justify-content-center"
                        style="width: 100px; border-radius: 4px"
                        :variant="getVariant(item?.state)"
                        >{{ item?.state }}</b-alert
                      >
                    </td>
                    <td style="width: 120px">
                      <b-dropdown
                        text="Action"
                        size="sm"
                        variant="outline-primary"
                      >
                        <b-dropdown-item
                          @click="
                            () => {
                              showCanvas = true
                              selectedData = item
                            }
                          "
                        >
                          View Detail Transaction</b-dropdown-item
                        >
                        <b-dropdown-item @click="handleDelete(item)">
                          Delete Transaction</b-dropdown-item
                        >
                        <template v-if="item?.state == 'requested'">
                          <b-dropdown-item
                            @click="() => handleConfirm(item, 'approve')"
                            ><i class="fa fa-thumbs-up text-success mr-1"></i>
                            Approved</b-dropdown-item
                          >
                          <b-dropdown-item
                            @click="() => handleConfirm(item, 'reject')"
                            ><i class="fa fa-close text-danger mr-2"></i>
                            Rejected</b-dropdown-item
                          >
                        </template>
                      </b-dropdown>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
            <div
              v-if="loading"
              class="w-100 d-flex justify-content-center py-5"
            >
              <b-spinner></b-spinner>
            </div>
            <div
              v-if="!loading && !adjustments?.data?.length"
              class="w-100 d-flex justify-content-center py-4"
            >
              No Data Here!
            </div>
          </b-col>
        </b-row>
      </template>
    </iq-card>
  </b-container>
</template>
<script>
import UserTemplate from '@/src/components/global/Partial/UserTemplate.vue'
import FormAdjustmentRunningHours from './FormAdjustmentRunningHours.vue'
import { maintenanceActions, pmsActions } from '@/src/Utils/helper'

export default {
  components: { FormAdjustmentRunningHours, UserTemplate },
  name: 'AdjustmentRunningHourNew',
  data() {
    return {
      loading: false,
      showModalFilter: false,
      showCanvas: false,
      selectedData: null,
      statusSelected: [],
      filterSearch: '',
      filterDate: '',
      adjustments: {
        page: 1,
        perPage: 10,
        totalPage: 1,
        data: [],
      },
      statusOptions: [
        {
          name: 'Requested',
          value: 'requested',
        },
        {
          name: 'Rejected',
          value: 'rejected',
        },
        {
          name: 'Completed',
          value: 'completed',
        },
      ],
    }
  },
  methods: {
    ...maintenanceActions,
    ...pmsActions,
    async handleAction(item, action) {
      try {
        const actMsg = action == 'reject' ? 'Reject' : 'Approve'
        const res = await this.saveAdjustmentRunningHourAction({
          action,
          id: item.id,
        })
        this.$swal(
          'Success',
          res?.data?.message ?? `Success ${actMsg} Adjusment Running Hours`,
          'success'
        )
        this.fetchData()
      } catch (error) {
        console.log(error)
        this.$swal(
          'Error',
          error.response?.data?.message ??
            `Failed ${actMsg} Adjusment Running Hours`,
          'error'
        )
      }
    },
    handleConfirm(data, action) {
      const actMsg = action == 'reject' ? 'Reject' : 'Approve'
      this.$swal({
        title: `${actMsg} Data?`,
        text: `Once ${actMsg}, this action cannot be reversed.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: actMsg,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.handleAction(data, action)
        }
      })
    },
    async fetchData() {
      this.loading = true
      try {
        const params = {
          page: this.adjustments?.page || 1,
          limit: this.adjustments?.perPage,
          state: `${this.statusSelected?.map((el) => el.value)}`,
        }
        if (!params.state) delete params.state
        const res = await this.getAdjustmentRhV3(params)
        this.adjustments = res?.data
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    getVariant(status) {
      switch (status) {
        case 'requested':
          return 'primary'
        case 'approved':
        case 'completed':
          return 'success'
        case 'rejected':
          return 'danger'
        default:
          return 'secondary'
      }
    },
    handleDelete(data) {
      this.$swal({
        title: 'Delete Data?',
        text: `Data will be deleted and cannot be recovered.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let res = await this.deleteAdjustmentRhV3(data.id)
          if (res.status !== 'success') {
            this.$swal(
              'Error',
              res.data.message ??
                'Something wrong with the server. Cannot get user data.',
              'error'
            )
          } else {
            this.fetchData()
            this.$swal(`Data deleted!`, 'success')
          }
        }
      })
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>

<style scoped>
table th {
  padding: 8px 12px;
}
table td {
  padding: 8px 12px;
  color: black;
}
</style>
